var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMymedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1111_2999)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31,
    width: 157,
    height: 157,
    rx: 78.5,
    fill: "white",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1111_2999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.25 79.5H94.75C91.7673 79.5033 88.9078 80.6896 86.7987 82.7987C84.6896 84.9078 83.5033 87.7673 83.5 90.75V128.25C83.5033 131.233 84.6896 134.092 86.7987 136.201C88.9078 138.31 91.7673 139.497 94.75 139.5H132.25C135.233 139.497 138.092 138.31 140.201 136.201C142.31 134.092 143.497 131.233 143.5 128.25V90.75C143.497 87.7673 142.31 84.9078 140.201 82.7987C138.092 80.6896 135.233 79.5033 132.25 79.5ZM94.75 87H132.25C133.245 87 134.198 87.3951 134.902 88.0983C135.605 88.8016 136 89.7554 136 90.75V128.25C136.001 128.742 135.904 129.23 135.715 129.685C135.526 130.14 135.249 130.553 134.9 130.9L113.07 109.07C111.195 107.195 108.652 106.142 106 106.142C103.348 106.142 100.805 107.195 98.93 109.07L91 117V90.75C91 89.7554 91.3951 88.8016 92.0983 88.0983C92.8016 87.3951 93.7554 87 94.75 87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.25 104.5C125.702 104.5 128.5 101.702 128.5 98.25C128.5 94.7982 125.702 92 122.25 92C118.798 92 116 94.7982 116 98.25C116 101.702 118.798 104.5 122.25 104.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1111_2999",
    x: 0.700001,
    y: 0.700001,
    width: 225.6,
    height: 225.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1111_2999"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1111_2999",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_2999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(83.5 79.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMymedia);
export default __webpack_public_path__ + "static/media/mymedia.63fe7d7397e5e47bfb9f7361e8f48dc9.svg";
export { ForwardRef as ReactComponent };